<template>
    <div v-if="paginator && paginator.links!==undefined" class="mt-8 text-center">
      <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
        <a v-if="paginator.links[0].url" @click="$emit('pageclick', paginator.links[0].url)" class="relative cursor-pointer inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
          <span class="sr-only">Previous</span>
          <!-- Heroicon name: solid/chevron-left -->
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        </a>
        <a v-else class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500">
          <span class="sr-only">Previous</span>
          <!-- Heroicon name: solid/chevron-left -->
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        </a>
        <template v-for="itemLink in getLinks" :key="itemLink.label">
            <a v-if="itemLink.active" class="relative inline-flex items-center bg-blue-100 px-4 py-2 border border-gray-300 bg-white text-sm font-bold text-blue-700">
            {{ itemLink.label }}
            </a>
            <a v-else-if="!itemLink.url" class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-bold text-gray-700">
            {{ itemLink.label }}
            </a>
            <a v-else @click="$emit('pageclick', itemLink.url)" class="relative cursor-pointer inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50">
            {{ itemLink.label }}
            </a>
        </template>
        <a v-if="paginator.links[paginator.links.length-1].url" @click="$emit('pageclick', paginator.links[paginator.links.length-1].url)" class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
          <span class="sr-only">Next</span>
          <!-- Heroicon name: solid/chevron-right -->
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
          </svg>
        </a>
        <a v-else class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500">
          <span class="sr-only">Next</span>
          <!-- Heroicon name: solid/chevron-right -->
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
          </svg>
        </a>
      </nav>
    </div>

</template>

<script>

export default {
    name: "paginator",
    props: {
        paginator: {
            current_page: Number,
            from: Number,
            last_page: Number,
            links: Array,
            path: String,
            per_page: Number,
            to: Number,
            total: Number,
        }
    },
    emits: ['pageclick'],
    methods: {
        isFirstOrLastOrDots(index,links_length,label) {
            return index===0 || index===links_length-1 || label.includes('...')
        },
    },

    computed: {
        getLinks() {
            if (this.paginator.links) {
                const arr = this.paginator.links.filter((item , index)=>{
                    return index > 0 && index < this.paginator.links.length-1; //will return the array from the second item and ignore last item
                })
                return arr;
            }
            return [];
        }
    }
}
</script>